import { createContext } from "react";

export type LocalizationState = {
  locale: string;
};

export type AnalyticsState = {
  consent?: boolean;
  consentDecision?: number;
};

export const defaultAnalyticsState: AnalyticsState = {};

const ApplicationContext = createContext<{
  setLocalizationState: (newState: LocalizationState) => void;
  analytics: AnalyticsState;
  setAnalyticsState: (newState: AnalyticsState) => void;
}>({
  setLocalizationState: () => {},

  analytics: defaultAnalyticsState,
  setAnalyticsState: () => {},
});

export default ApplicationContext;
